import React, { JSX } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

interface Props {
  size?: JSX.Element | any;
  show?: boolean;
  headerEl?: JSX.Element | any;
  bodyEl?: JSX.Element | any;
  footerEl?: JSX.Element | any;
  isModalScrollable?: boolean;
  backdrop?: any;
  className?: string;
  modalClassName?: string;
  enforceFocus?: boolean;
  onHide?: () => any;
}

export default function VerticallyCenteredModal(props: Props) {
  const {
    className,
    modalClassName,
    size = 'lg',
    show = false,
    enforceFocus,
    onHide,
    isModalScrollable = false,
    headerEl = <h3>Header</h3>,
    bodyEl = <div>body</div>,
    footerEl = (
      <div>
        <Button onClick={onHide}>Close</Button>
      </div>
    ),
    backdrop = false,
  } = props;
  return (
    <Modal
      show={show}
      size={size}
      backdrop={backdrop}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
      dialogClassName={className}
      enforceFocus={enforceFocus}
      className={`${isModalScrollable ? 'modal-scrollable ' : ''}${modalClassName ? ` ${modalClassName}` : ''}`.trim()}
    >
      {headerEl}
      {bodyEl}
      {footerEl}
    </Modal>
  );
}
